// ── CallRegister 폼 영역 스타일 ──────────────────────────────────────────────
// 등록 폼, 스프레드시트 셀, 입력 필드, 버튼, 수정 모달 필드 관련 스타일
// dark mode: CSS 변수 토큰 사용 (index.css .dark{} 에서 자동 전환)

/** 섹션(등록 폼·목록) 래퍼: 겉 박스 없음 — 테두리·배경을 두지 않는다 (2026-09-15 사용자 요청).
 *  휴대폰 좌우 16px 은 이제 공통 틀(AdminLayout main)이 준다(2026-09-28) — 여기서는 0. */
export const sectionStyle = (isMobile) => ({
  minWidth: 0,
  // 휴대폰은 공통 틀(AdminLayout main)이 좌우 16px 을 준다 — 겹치지 않게 0 (2026-09-28)
  ...(isMobile && { paddingInline: 0 }),
});

/** 등록 폼 섹션: 데스크톱은 아래 목록(전체검색)과 60px 띄운다 — 페이지 칸 간격 12px + 48px (2026-09-15 사용자 요청: 5배) */
export const registrationSectionStyle = (isMobile) => ({
  ...sectionStyle(isMobile),
  ...(!isMobile && { marginBottom: 48 }),
});

/** 폼 입력 필드 */
export const input = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '7px 9px',
  minHeight: 34,
  fontSize: 12,
  width: '100%',
  maxWidth: '100%',
  display: 'block',
  minWidth: 0,
  boxSizing: 'border-box',
  color: 'var(--text)',
  background: 'var(--bg-card)',
};

/** 등록/저장 버튼: 검정 배경, 흰색 텍스트 (stdBlackBtn 색 통일 — 기존 크기 유지) */
export const submitBtn = {
  border: '1px solid var(--std-btn, #0f172a)',
  background: 'var(--std-btn, #0f172a)',
  color: '#fff',
  borderRadius: 8,
  padding: '7px 10px',
  fontWeight: 700,
  cursor: 'pointer',
};

/** 보조 액션 버튼(수정 등): 배경, 연한 테두리 */
export const miniBtn = {
  border: '1px solid var(--border)',
  background: 'var(--bg-card)',
  color: 'var(--text-sub)',
  borderRadius: 7,
  padding: '5px 10px',
  fontWeight: 600,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  fontSize: 11,
};

/** 킵 토글 버튼: 활성(킵됨) amber, 비활성 neutral */
export const callKeepBtnStyle = (active) => ({
  border: `1px solid ${active ? '#f59e0b' : 'var(--border)'}`,
  background: active ? '#fef3c7' : 'var(--bg-subtle)',
  color: active ? '#92400e' : 'var(--text-muted)',
  borderRadius: 7,
  padding: '5px 10px',
  fontWeight: 700,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  fontSize: 11,
});

/** 빈 상태 텍스트: 중앙 정렬 */
export const empty = { color: 'var(--text-muted)', textAlign: 'center', padding: 16, fontSize: 13 };

/** 스프레드시트 래퍼: 라운드 테두리, 가로 스크롤
 *  overflowX: 'scroll' — 항상 스크롤바 렌더링 (감지 로직 없이 안정적) */
export const sheetWrapStyle = {
  border: '1px solid var(--border)',
  borderRadius: 10,
  background: 'var(--bg-card)',  // 겉 카드가 없어져도 표 안은 흰 바탕 유지
  overflowX: 'scroll',
  overflowY: 'clip',
};

/** 스프레드시트 행: 그리드 레이아웃, 하단 구분선 */
export const sheetRowStyle = {
  display: 'grid',
  width: '100%',
  borderBottom: '1px solid var(--border)',
};

/** 목록 제목 칸: 검정 배경 + 흰 글씨 (등록 폼 라벨 칸과 같은 반전 색 — 다크 모드에서 자동 반전, 2026-09-15) */
export const headerCell = {
  borderRight: '1px solid rgba(127, 127, 127, 0.3)',
  padding: '8px 10px',
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--bg-card)',
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  background: 'var(--text)',
  borderBottom: '1px solid var(--border)',
};

/** 데이터 값 셀: 우측 구분선, 폰트 색상 통일 */
export const valueCell = {
  borderRight: '1px solid var(--border)',
  padding: '8px 10px',
  fontSize: 11,
  color: 'var(--text-sub)',
  display: 'flex',
  alignItems: 'center',
  overflowWrap: 'anywhere',
};

/** 관리자 모드 값 셀: 단일 줄 표시(말줄임) */
export const singleLineValueCell = {
  ...valueCell,
  overflowWrap: 'normal',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

/** 모바일: 마케팅담당자 필드 + 고정 옵션 세로 배치 */
export const mobileSalesWrap = { display: 'grid', gap: 6 };

/** 모바일: 담당자 고정 체크박스 레이블 */
export const mobileFixedLabel = { display: 'inline-flex', gap: 6, alignItems: 'center', fontSize: 12, color: 'var(--text-sub)', fontWeight: 700 };

/** 모바일: 날짜 선택 필드(커스텀 UI + 숨겨진 네이티브 input) */
export const mobileDateFieldStyle = {
  position: 'relative',
  border: '1px solid var(--border)',
  borderRadius: 8,
  minHeight: 34,
  padding: '7px 34px 7px 9px',
  display: 'flex',
  alignItems: 'center',
  background: 'var(--bg-card)',
};

/** 모바일: 날짜 표시 텍스트 */
export const mobileDateTextStyle = {
  fontSize: 12,
  lineHeight: 1.2,
  color: 'var(--text-sub)',
};

/** 모바일: 달력 아이콘 (우측 고정) */
export const mobileDateIconStyle = {
  position: 'absolute',
  right: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 14,
  color: 'var(--text-muted)',
  pointerEvents: 'none',
};

/** 모바일: 네이티브 date input (투명, 클릭 영역으로만 활용) */
export const mobileDateNativeInputStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  opacity: 0,
  border: 'none',
  margin: 0,
  padding: 0,
  cursor: 'pointer',
};

/** 수정 모달: 레이블 + 입력 필드 행 */
export const editFieldGrid = { display: 'flex', alignItems: 'center', gap: 8 };

/** 수정 모달: 필드 레이블 */
export const editFieldLabel = { fontSize: 12, color: 'var(--text-sub)', fontWeight: 700, width: 88, flexShrink: 0 };

/** 수정 모달: 입력 필드 */
export const editFieldInput = { ...input, flex: 1, width: 'auto', minWidth: 0, overflow: 'hidden' };

/** 컬럼 리사이즈 핸들: 헤더 우측 가장자리에 드래그 가능한 영역 */
export const colResizeHandle = { position: 'absolute', top: 0, right: -3, width: 8, height: '100%', cursor: 'col-resize', zIndex: 3 };

/** 등록 성공 결과 텍스트: 초록색 굵은 폰트 */
export const submitResultTextStyle = { color: '#16a34a', fontWeight: 800, fontSize: 12 };

/** 삭제 버튼: 연한 빨간 배경으로 위험 액션 경고 */
export const dangerMiniBtn = {
  border: '1px solid #fecaca',
  background: '#fef2f2',
  color: '#b91c1c',
  borderRadius: 7,
  padding: '5px 10px',
  fontWeight: 700,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  fontSize: 11,
};

/** 삭제 버튼 비활성: 당일 콜이 아니거나 계약완료 */
export const dangerMiniBtn_disabled = {
  border: '1px solid var(--border)',
  background: 'var(--bg-subtle)',
  color: 'var(--text-muted)',
  borderRadius: 7,
  padding: '5px 10px',
  fontWeight: 700,
  cursor: 'not-allowed',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  fontSize: 11,
};

/** 수정 버튼 비활성: 계약완료 콜 */
export const miniBtn_disabled = {
  border: '1px solid var(--border)',
  background: 'var(--bg-subtle)',
  color: 'var(--text-muted)',
  borderRadius: 7,
  padding: '5px 10px',
  fontWeight: 700,
  cursor: 'not-allowed',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  fontSize: 11,
};
